import { useState } from 'react';

export default function FAQSection() {
  const [activeIndex, setActiveIndex] = useState<number | null>(null);

  const faqs = [
    {
      question: 'まったくのお任せで、退去立会いの状態までやっていただけますか？',
      answer: 'はい。カギさえ開けていただければ、家の中の荷物を全て回収します。 ハウスクリーニングは別になります。'
    },
    {
      question: '予算に合わせてのお見積りも可能ですか？',
      answer: 'はい。お客様の予算の都合に合わせて、お客様自身でやっていただくことなどによって 金額調整は可能です。'
    },
    {
      question: '見積もりにどれくらいの時間がかかりますか？',
      answer: '家の広さによって多少異なりますが、普通の一軒家で20～30分程度になります。'
    },
    {
      question: '急ぎでも対応できますか？',
      answer: '内容によりますが、対応できるよう体制を整えておりますので、ご相談ください。'
    },
    {
      question: 'どんな人が来るのですか？',
      answer: '研修を受けた弊社スタッフがお伺いします。必ず自社スタッフのみになります。'
    },
    {
      question: '探してもらいたいものがあるのですが・・',
      answer: '物の特徴などを詳しく説明していただければ、精一杯探しながら作業させていただきます。'
    },
    {
      question: '孤独死でお部屋が汚れていますが大丈夫ですか？',
      answer: 'もちろんです。日々遺品整理に従事しているプロのスタッフですのでお任せください。'
    },
    {
      question: '仏壇の供養はしていただけますか？',
      answer: '基本的にいつもお世話になっているお寺さんに精抜きをお願いしていただいた方が良いです。 ご不明な場合はご相談いただければ対応いたします。'
    }
  ];

  const toggleFAQ = (index: number) => {
    setActiveIndex(activeIndex === index ? null : index);
  };

  return (
    <section id="faq" className="py-24 bg-white">
      <div className="max-w-4xl mx-auto px-6">
        {/* Header */}
        <div className="text-center mb-16">
          <div className="inline-flex items-center gap-2 bg-pink-100 px-4 py-2 rounded-full mb-4">
            <i className="ri-question-answer-line text-primary"></i>
            <span className="text-primary font-semibold text-sm">よくある質問</span>
          </div>
          <h2 className="text-4xl md:text-5xl font-bold text-gray-900 mb-4">
            ゴミ屋敷の不用品回収の <strong className="text-primary">FAQ</strong>
          </h2>
          <p className="text-xl text-gray-600 max-w-3xl mx-auto">
            お客様からよくいただくご質問にお答えします。
          </p>
        </div>

        <div className="space-y-4">
          {faqs.map((faq, index) => (
            <div 
              key={index} 
              className="border border-gray-200 rounded-xl overflow-hidden hover:border-primary transition-colors"
            >
              <button
                className="w-full px-6 py-4 flex items-center justify-between text-left focus:outline-none"
                onClick={() => toggleFAQ(index)}
              >
                <div className="flex items-center gap-4">
                  <span className="flex-shrink-0 w-8 h-8 bg-primary text-white rounded-full flex items-center justify-center font-bold">Q</span>
                  <span className="font-bold text-gray-900">{faq.question}</span>
                </div>
                <i className={`ri-arrow-down-s-line text-2xl text-gray-400 transition-transform duration-300 ${activeIndex === index ? 'rotate-180' : ''}`}></i>
              </button>
              
              <div 
                className={`transition-all duration-300 ease-in-out overflow-hidden ${
                  activeIndex === index ? 'max-h-96 opacity-100' : 'max-h-0 opacity-0'
                }`}
              >
                <div className="px-6 pb-6 pl-[4.5rem]">
                  <div className="flex items-start gap-4">
                    <span className="flex-shrink-0 w-8 h-8 bg-gray-100 text-primary rounded-full flex items-center justify-center font-bold">A</span>
                    <p className="text-gray-600 leading-relaxed pt-1">{faq.answer}</p>
                  </div>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
